export default __webpack_public_path__ + "static/media/live_chat_en.70a1a039.png";